import { useEffect, useState } from "react";
import "./App.css";

import { returnMockData, returnRegenerate } from "./Services/mockData";
import apiService from "./Services/apiServices";
import MainChatPage from "./Pages/MainChatPage.js/MainChatPage";

var count = 0;
let globalMessages = [];
let serverData = {};
function App() {
  const [minimized, setMinimize] = useState(false);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [showMaximumChat, setIsShowMaximumChat] = useState(false);
  const [showMinimizedChat, setShowMinimizedChat] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const [token, setToken] = useState("");
  const [isShowBot, setIsShowBot] = useState(false);
  const [code, setCode] = useState("");
  const [sessionId, setSessionId] = useState(Number);
  const [reLogin , setRelogin] = useState(false)

    //handleTabClosure event
    useEffect(() => {
      const handleTabClosure = () => {
        apiService.loginForRefresh('6').then((res) => {
          console.log(res);
        });
      };
  
      window.addEventListener("beforeunload", handleTabClosure);
  
  
      return () => {
        window.removeEventListener("beforeunload", handleTabClosure);
      };
    }, []);
  
    //handleBackButton event
    useEffect(() => {
      const handleBackButton = () => {
        apiService.loginForRefresh('6').then((res) => {
          console.log(res);
        });
      };
  
      window.addEventListener("popstate", handleBackButton);
  
      return () => {
        window.removeEventListener("popstate", handleBackButton);
      };
    }, []);

  const decode = (encodedStringURI) => {
    if (!encodedStringURI) {
      return null;
    }
    try {
      let decodedStringURI = decodeURIComponent(encodedStringURI);
      let decodedBase64String = atob(decodedStringURI);
      let decodedSurveyConfiguration = JSON.parse(decodedBase64String);
      setUserDetails(decodedSurveyConfiguration?.agentId ||decodedSurveyConfiguration?.userDetails);
      return decodedSurveyConfiguration;
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    let configEncodedString = ( window.location.search || window.location.pathname || "").substring(
      1,
      ( window.location.search || window.location.pathname || "").length
    );
    let user = decode(configEncodedString);
    sessionStorage.setItem("agenIdS360", user?.agentId);
    function extractTextAfterData(url) {
      const regex = /data=(.*)/;
      const match = url.match(regex);
      return match ? match[1] : "";
    }
    if (!userDetails) {
      let userCode = extractTextAfterData(window.location.href)
      sessionStorage.setItem("userIdS360", userCode);
      setUserDetails(userCode);

    }
  }, []);
  useEffect(() => {
    if (showMaximumChat) {
      window.parent.postMessage({ screenMode: "fullScreen" }, "*");
    } else if (showMinimizedChat) {
      window.parent.postMessage({ screenMode: "minimized" }, "*");
    } else if (isShowBot) {
      window.parent.postMessage({ screenMode: "normal" }, "*");
    } else {
      window.parent.postMessage({ screenMode: "icon" }, "*");
    }
  }, [showMaximumChat, showMinimizedChat, isShowBot]);

  const addMessages = async (msg) => {
    try {
       const timestamp = new Date().toLocaleString('en-IN', {
        weekday: 'long',
        hour: "2-digit",
        minute: "2-digit",
        hour12: true // Use 12-hour clock format (pm/am)
    });
      setCount((prevCount) => prevCount + 1);
      const customerMsg = {
        text: msg,
        type: "CUSTOMER",
        date: new Date().toISOString(),
        messageCount: `CUSTOMER-${count + 1}`,
        time : timestamp
      };
      setLoading(true);
      setMessages((prevMessages) => [...prevMessages, customerMsg]);

      // Add a placeholder for the server response with a loading indicator
      const loadingPlaceholder = {
        text: "...",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: true,
        time : timestamp
      };
      setMessages((prevMessages) => [...prevMessages, loadingPlaceholder]);

      // Simulate API call to retrieve server response
      let serverResponse = await apiService.inputResonse({
        input: encodeURIComponent(
          JSON.stringify({
            key1: msg,
            count: Math.random(),
          })
        ),
        token: token,
        bot: "agent-assist",
        code: code,
      });

      // Parse the server response

      // let res = JSON.parse(serverResponse);
       // Check the server response code
    if (serverResponse?.data?.code !== 200) {
      const errorMsg = {
        text: "Failed to get a response from the server. Please try again later.",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: false,
        isFailed: true,
        time : timestamp
      };

      // Replace the loading placeholder with the error message
      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
      return;
    }
      let data = serverResponse?.data?.chatResponse;

      let serverData = {};

      if (data?.entries.length > 0) {
        if (data?.entries?.some((el) => el?.uiCommand === "A3f")) {
          const entryA3 = data?.entries?.find((item) => item.uiCommand === "A3f");
          serverData = {
            text: entryA3?.text,
            type: "ERROR",
            date: new Date().toISOString(),
            messageCount: `ERROR-${count + 1}`,
            isLoading: false,
            isFailed: true,
            time : timestamp
          };
          serverData.type = "SERVER";
          serverData.messageCount = `SERVER-${count + 1}`;
          setLoading(false);
        } else if (data?.entries?.some((el) => el?.uiCommand === "A3")) {
          const entryA3 = data?.entries?.find(
            (item) => item.uiCommand === "A3"
          );
          if (entryA3) {
            serverData = JSON.parse(entryA3?.text);
          }
          if (!sessionId) {
            setSessionId(Number(serverData?.session_id));
          }

          serverData.type = "SERVER";
          serverData.messageCount = `SERVER-${count + 1}`;
          serverData.time = timestamp
          setLoading(false);
          // Further code for handling the "A3" case goes here
        }
        
        if (data?.entries?.some((el) => el?.uiCommand === "A14")) {
          const entryA14 = data?.entries?.find(
            (item) => item.uiCommand === "A14"
          );
          setCode(entryA14?.code);
        }
      }

      if (data?.end) {
        serverData = {
          text: "Failed to get a response from the server. Please try again later.",
          type: "ERROR",
          date: new Date().toISOString(),
          messageCount: `ERROR-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time : timestamp
        };
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        setRelogin(true)
        setLoading(false);
      }

      // Add type and message count to server data
      // serverData.type = "SERVER";
      // serverData.messageCount = `SERVER-${count + 1}`;
      // serverData.isLoading = false;
  
      // Replace the placeholder with the actual server response
      setMessages((prevMessages) =>
        prevMessages.map((message) =>
          message.isLoading ? serverData : message
        )
      );
      setLoading(false);
    } catch (error) {
      console.error("Error adding messages:", error);
      const timestamp = new Date().toLocaleString('en-IN', {
        weekday: 'long',
        hour: "2-digit",
        minute: "2-digit",
        hour12: true // Use 12-hour clock format (pm/am)
    });

      // Show an error message in the chat
      const errorMsg = {
        text: "Failed to get a response from the server. Please try again later.",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: false,
        isFailed: true,
        time : timestamp
      };

      // Replace the loading placeholder with the error message
      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
    }
  };

  const addMessagesMockData = async (msg) => {
    //local data
    try {
      setCount((prevCount) => prevCount + 1);
      const customerMsg = {
        text: msg,
        type: "CUSTOMER",
        date: new Date().toISOString(),
        messageCount: `CUSTOMER-${count + 1}`,
      };
      setLoading(true);
      setMessages((prevMessages) => [...prevMessages, customerMsg]);

      // Add a placeholder for the server response with a loading indicator
      const loadingPlaceholder = {
        text: "...",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: true,
      };
      setMessages((prevMessages) => [...prevMessages, loadingPlaceholder]);

      // Simulate a delay for the mock data
      // let serverData = returnMockData(msg)
      let serverData = await new Promise((resolve) => {
        setTimeout(() => {
          resolve(returnMockData(msg));
        }, 3000);
      });
      serverData.type = "SERVER";
      serverData.messageCount = `SERVER-${count + 1}`;

      // Replace the placeholder with the actual server response
      setMessages((prevMessages) =>
        prevMessages.map((message) =>
          message.isLoading ? serverData : message
        )
      );
      setLoading(false);
    } catch (error) {
      console.error("Error adding messages:", error);

      // Show an error message in the chat
      const errorMsg = {
        text: "Failed to get a response from the server. Please try again later.",
        type: "ERROR",
        date: new Date().toISOString(),
        messageCount: `ERROR-${count + 1}`,
        isLoading: false,
      };

      // Replace the loading placeholder with the error message
      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
    }
  };

  const updateMessage = async (msgBody) => {
    console.log(msgBody);
    // Find message by id i.e messageCount
    //call api to update message
    let tempMsgBody = msgBody;
    delete tempMsgBody.messageCount;
    delete tempMsgBody.llm_response;
    delete tempMsgBody.type;
    tempMsgBody.offset = 5;
    tempMsgBody.temperature = 0.1;
    const timestamp = new Date().toLocaleString('en-IN', {
      weekday: 'long',
      hour: "2-digit",
      minute: "2-digit",
      hour12: true // Use 12-hour clock format (pm/am)
  });

    try {
      setLoading(true);
      // Add a placeholder for the server response with a loading indicator
      const loadingPlaceholder = {
        text: "...",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: true,
        time : timestamp
      };
      setMessages((prevMessages) => {
        const updatedNames = [...prevMessages];
        updatedNames[updatedNames.length - 1] = loadingPlaceholder;
        return updatedNames;
      });

      let serverResponse = await apiService.inputResonse({
        input: encodeURIComponent(
          JSON.stringify({
            key1: msgBody,
            count: Math.random(),
          })
        ),
        token: token,
        bot: "agent-assist",
        code: code,
        refresh: true,
      });

            // Check the server response code
      if (serverResponse?.data?.code !== 200) {
        const errorMsg = {
          text: "Failed to get a response from the server. Please try again later.",
          type: "SERVER",
          date: new Date().toISOString(),
          messageCount: `SERVER-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time : timestamp
        };

        // Replace the loading placeholder with the error message
        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          updatedMessages[updatedMessages.length - 1] = errorMsg;
          return updatedMessages;
        });
        setLoading(false);
        return;
      }
      let data = serverResponse?.data?.chatResponse;

      let serverData = {};
      if (data?.entries?.length > 0) {
        // if (data?.entries?.some((el) => el?.uiCommand === "A3")) {
        //   const entryA3 = data?.entries?.find(item => item.uiCommand === "A3");
        //   if(entryA3){
        //     serverData =JSON.parse(entryA3?.text)
        //   }

        //   serverData.type = "SERVER"
        //   serverData.messageCount = `SERVER-${count + 1}`
        //   setLoading(false);
        // }

        if (data?.entries?.some((el) => el?.uiCommand === "A3f")) {
          const entryA3 = data?.entries?.find(
            (item) => item.uiCommand === "A3f"
          );
          serverData = {
            text: entryA3?.text,
            type: "ERROR",
            date: new Date().toISOString(),
            messageCount: `ERROR-${count + 1}`,
            isLoading: false,
            isFailed: true,
            time : timestamp
          };
          serverData.type = "SERVER";
          serverData.messageCount = `SERVER-${count + 1}`;
          setLoading(false);
        } else if (data?.entries?.some((el) => el?.uiCommand === "A3")) {
          const entryA3 = data?.entries?.find(
            (item) => item.uiCommand === "A3"
          );
          
        if (entryA3) {
          serverData = JSON.parse(entryA3?.text);
        }

          serverData.type = "SERVER";
          serverData.messageCount = `SERVER-${count + 1}`;
          serverData.time = timestamp
          setLoading(false);
        }

        if (data?.entries?.some((el) => el?.uiCommand === "A14")) {
          const entryA14 = data?.entries?.find(
            (item) => item.uiCommand === "A14"
          );
          setCode(entryA14?.code);
        }
      }

      if (data?.end) {
        serverData = {
          text: "Failed to get a response from the server. Please try again later.",
          type: "ERROR",
          date: new Date().toISOString(),
          messageCount: `ERROR-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time : timestamp
        };
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        setRelogin(true)
        setLoading(false);

      }

      setMessages((prevState) => {
        const updatedNames = [...prevState];
        updatedNames[updatedNames.length - 1] = serverData;
        return updatedNames;
      });
      setLoading(false);
    } catch (error) {
      console.error("Error adding messages:", error);
      // Handle errors here
    }
  };
  const clearMessages = () => {
    setMessages([]);
  };
  useEffect(() => {
    console.log(messages);
  }, [messages]);

  return (
    <div className="App">
      <MainChatPage
        minimized={minimized}
        messages={messages}
        addMessages={addMessages}
        clearMessages={clearMessages}
        loading={loading}
        updateMessage={updateMessage}
        showMaximumChat={showMaximumChat}
        setIsShowMaximumChat={setIsShowMaximumChat}
        showMinimizedChat={showMinimizedChat}
        setShowMinimizedChat={setShowMinimizedChat}
        userDetails={userDetails}
        setToken={setToken}
        isShowBot={isShowBot}
        setIsShowBot={setIsShowBot}
        setCode={setCode}
        token={token}
        sessionId={sessionId}
        reLogin={reLogin}
        setRelogin={setRelogin}
      />
    </div>
  );
}

export default App;
